import { render, staticRenderFns } from "./Titles.vue?vue&type=template&id=6d096730&scoped=true&lang=pug&"
import script from "./Titles.vue?vue&type=script&lang=js&"
export * from "./Titles.vue?vue&type=script&lang=js&"
import style0 from "./Titles.vue?vue&type=style&index=0&id=6d096730&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d096730",
  null
  
)

export default component.exports